import { custom, success } from "./utilities";
import { recruiterConstants, globalConstants } from "../../constants";
import { recruiterService } from "../../services/recruiter.services";
import { ToastifyService } from "../../services/toastify.services";
import * as XLSX from "xlsx";

const gridData = {
  length: 10,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: null,
  search: null,
  filterExpression: globalConstants.FILTER_EXPRESSION
};

export const getAllRecruiters = (gridState) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    recruiterService
      .getAll(gridState)
      .then((response) => {
        dispatch(success(response, recruiterConstants.GET_RECRUITERS));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getRecruiterById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    recruiterService
      .getById(id)
      .then((response) => {
        dispatch(success(response, recruiterConstants.GET_RECRUITER_BY_ID));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const deleteRecruiterById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    recruiterService
      .deleteById(id)
      .then((response) => {
        dispatch(getAllRecruiters(gridData));
        ToastifyService.showSuccess("Status Updated Successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const createRecruiter = (data, onHide) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    recruiterService
      .create(data)
      .then((response) => {
        dispatch(getAllRecruiters(gridData));
        onHide();
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const updateRecruiter = (data, onHide) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    recruiterService
      .update(data)
      .then((response) => {
        dispatch(getAllRecruiters(gridData));
        onHide();
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getAllRecruiterList = () => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    recruiterService
      .getAllList()
      .then((response) => {
        dispatch(
          success(response.items, recruiterConstants.GET_RECRUITER_LIST)
        );
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getAllAssignedProjects = (gridState, id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    recruiterService
      .getAllAssignedProjects(gridState, id)
      .then((response) => {
        dispatch(
          success(response, recruiterConstants.GET_RECRUITER_ASSIGNED_PROJECTS)
        );
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const report = (data) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    recruiterService
      .report(data)
      .then((response) => {
       const rows = response.items;

        if (!rows || rows.length === 0) {
          ToastifyService.showError("No data found for selected filters");
          return;
        }

        // Create Excel from JSON
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          "Recruiter Report"
        );

        XLSX.writeFile(
          workbook,
          `Recruiter_Report_${data.StartDate}_to_${data.EndDate}.xlsx`
        );

        ToastifyService.showSuccess("Report downloaded successfully");
      })
      .catch((error) => ToastifyService.showError("Failed to generate report"))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const recruiterActions = {
  getAllRecruiters,
  getRecruiterById,
  deleteRecruiterById,
  createRecruiter,
  updateRecruiter,
  getAllRecruiterList,
  getAllAssignedProjects,
  report
};
